import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from '@/api/PMS/baseInformation/customer';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
import { fetchListByType } from '@/api/PMS/dic/dic';
import waves from '@/directive/waves'; // 水波纹指令

import customerAdd from './add';
import customerDetail from './detail';
export default {
  components: {
    customerAdd: customerAdd,
    customerDetail: customerDetail
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: false,
      typeOption: [],
      options: [],
      searchId: [],
      cascaderItem: [],
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      listQuery: {
        page: 1,
        limit: 10,
        dataType: '',
        customerName: '',
        id: '',
        customerType: 1
      },
      title: '',
      customerId: '',
      multipleSelection: [],
      dialogFormVisible: false,
      dialogDetailFormVisible: false,
      downloadUrl: '',
      owerRelationList: [],
      dialogPicVisible: false,
      imgUrl: null
    };
  },
  watch: {
    searchId: function searchId(val) {
      this.listQuery.id = val[val.length - 1];
    },
    deep: true
  },
  created: function created() {
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.typeOption = [];
    this.cascaderItem = [];
    this.getList();
    this.loadMenuTree();
    this.loadTypeOptions();
    this.loadOwerRelationOptions();
  },
  methods: {
    showPic: function showPic(url) {
      console.log('图片地址', url);
      this.imgUrl = url;
      this.dialogPicVisible = true;
    },
    loadOwerRelationOptions: function loadOwerRelationOptions() {
      var _this = this;

      // 与业主关系
      fetchListByType('ower_relation').then(function (res) {
        _this.owerRelationList = res.data.data;
      });
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogDetailFormVisible = false;
      this.dialogFormVisible = false;
    },
    // 获取具体的下拉选项的数据
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this2 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this2.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    handTreeSelect: function handTreeSelect(val) {
      this.cascaderItem = [];
      this.getCascaderItem(this.searchId, this.options);
      this.listQuery.dataType = this.cascaderItem[this.cascaderItem.length - 1].flag;
      console.log(this.listQuery.dataType);
    },
    loadMenuTree: function loadMenuTree() {
      var _this3 = this;

      var treeQuery = {
        flag: 1
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this3.options = response.data.data;
      });
    },
    getStr: function getStr(str) {
      if (str) return str.substring(0, 10);else return str;
    },
    // changeTypeValue(val) {
    //   let obj = {}
    //   obj = this.locations.find(item => {
    //     return item.customerType === val
    //   })
    //   this.listQuery.customerType = obj.dicName
    // },
    loadTypeOptions: function loadTypeOptions() {
      var _this4 = this;

      fetchListByType('customer_type').then(function (r) {
        _this4.typeOption = r.data.data;
      });
    },
    getList: function getList() {
      var _this5 = this;

      this.listLoading = true; // this.listQuery.isRent = 0

      this.listQuery.customerType = 1;
      this.listQuery.flag = 1;
      this.listQuery.lvZhlx = 12;
      fetchList(this.listQuery).then(function (response) {
        _this5.list = response.data.data; // console.log(this.list[0].userImgListVos[0].imgPath,'///');

        _this5.total = response.data.total;
        _this5.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDeclare: function handleDeclare(id) {
      var ids = [];
      ids.push(id);
      this.declare(ids);
    },
    handleDeclares: function handleDeclares() {
      var ids = [];
      this.multipleSelection.forEach(function (row) {
        ids.push(row.customerId);
      });
      this.declare(ids);
    },
    declare: function declare(ids) {
      var _this6 = this;

      if (ids.length > 0) {
        this.$confirm('你确定是要上报这些数据, 是否继续?', '提示').then(function () {
          customerDeclare({
            ids: ids
          }).then(function (response) {
            if (response && response.data.code === 200) {
              _this6.getList();

              _this6.Alert({
                alertType: 'add',
                message: '申报成功！'
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    showDeclare: function showDeclare(data) {
      if (data === '1') {
        return '已申报';
      } else if (data === '2') {
        return '变更';
      } else if (data === '0') {
        return '未申报';
      }
    },
    handleDetails: function handleDetails(customerId) {
      this.customerId = customerId;
      this.title = '详情';
      this.dialogDetailFormVisible = true;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.customerId = '';
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(customerId) {
      this.customerId = customerId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    delete: function _delete(customerIds) {
      var _this7 = this;

      if (customerIds.length > 0) {
        this.$confirm('你确定是要删除这些客户, 是否继续?', '提示').then(function () {
          fetchDelete(customerIds).then(function (res) {
            if (res.data.code === 200) {
              _this7.getList();

              _this7.$emit('refreshTree');

              _this7.Alert({
                alertType: 'delete'
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(customerId) {
      var customerIds = [];
      customerIds.push(customerId);
      this.delete(customerIds);
    },
    handleDeletes: function handleDeletes() {
      var customerIds = [];
      this.multipleSelection.forEach(function (row) {
        customerIds.push(row.customerId);
      });
      this.delete(customerIds);
    }
  }
};